<template>
    <div class="team-offices">

        <block v-show="showForm==false">
            <div class="text-center">
                <button @click.prevent="showForm = true" class="btn btn-success">
                    <i class="fa fa-plus"></i> Add new Office</button>
            </div>
        </block>

        <block v-show="showForm" title="Add new Office">

            <form-input :form="form" property="name" label="Name">
                <input v-model="office.name" type="text" class="form-control" placeholder="Name">
            </form-input>

            <form-array-input :form="form" v-model="office.emails" property="emails" placeholder="Email" label="Emails"></form-array-input>
            <form-array-input :form="form" v-model="office.phones" property="phones" placeholder="Phone" label="Phones"></form-array-input>
            <form-array-input :form="form" v-model="office.websites" property="websites" placeholder="Website" label="Websites"></form-array-input>

            <form-input :form="form" property="country_id">
                <select3 :value="office.country" @input="changeCountry" data-url="/api/countries" :value-key="`name.${$lang.current}`"></select3>
            </form-input>
            <form-input :form="form" property="city_id">
                <select3 :disabled="!office.country_id" :value="office.city" @input="changeCity" :data-url="`/api/countries/${office.country_id}/cities`" :value-key="`name.${$lang.current}`"></select3>
            </form-input>
            <form-input :form="form" property="area_id">
                <select3 :disabled="!office.city_id" :value="office.area" @input="changeArea" :data-url="`/api/cities/${office.city_id}/areas`" :value-key="`name.${$lang.current}`"></select3>
            </form-input>

            <form-input :form="form" property="subarea_id">
                <select3 :disabled="!office.area_id" :value="office.subarea" @input="office.subarea_id = $event.id; office.subarea = $event" :data-url="`/api/areas/${office.area_id}/subareas`" :value-key="`name.${$lang.current}`"></select3>
            </form-input>

            <form-input :form="form" property="street" label="Street">
                <input v-model="office.street" type="text" class="form-control" placeholder="Street address">
            </form-input>

            <form-input :form="form" property="longitude" label="Type Street name and place Marker">
                <location-finder disable-input :value="{longitude: office.longitude, latitude: office.latitude}" @input="office.longitude = $event.longitude; office.latitude = $event.latitude"></location-finder>
            </form-input>

            <form-input :form="form" property="registration_number" label="Registration Number">
                <input v-model="office.registration_number" type="text" class="form-control" placeholder="Registration Number (Matični broj)">
            </form-input>

            <form-input :form="form" property="tax_number" label="Tax Number">
                <input v-model="office.tax_number" type="text" class="form-control" placeholder="Tax Number">
            </form-input>

            <form-input :form="form" property="identification_number" label="Identification Number">
                <input v-model="office.identification_number" type="text" class="form-control" placeholder="Identification Number">
            </form-input>

            <div class="text-center">
                <button @click.prevent="addOffice" class="btn btn-success">
                    <i class="fa fa-plus"></i> Save office</button>

                <button @click.prevent="showForm = false;" class="btn btn-default">Cancel</button>
            </div>
        </block>


        <div :class="{'has-error': form.errors.has('offices')}">
            <span class="help-block" v-show="form.errors.has('offices')">
                {{ form.errors.get('offices') }}
            </span>
        </div>


        <div v-for="(o, ind) in form.offices">

            <block :title="'Office' + (ind +1)">

                <form-input :form="form" property="name" label="Name">
                    <input v-model="o.name" type="text" class="form-control" placeholder="Name">
                </form-input>

                <form-array-input :form="form" v-model="o.emails" property="emails" placeholder="Email" label="Emails"></form-array-input>
                <form-array-input :form="form" v-model="o.phones" property="phones" placeholder="Phone" label="Phones"></form-array-input>
                <form-array-input :form="form" v-model="o.websites" property="websites" placeholder="Website" label="Websites"></form-array-input>

                <form-input :form="form" property="country_id">
                    <!--<select3 :value="o.country" @input="o.country_id = $event.id; o.country = $event"  data-url="/api/countries" :value-key="`name.${$lang.current}`"></select3>-->
                    <select3 :value="o.country" @input="changeOfficeCountry(o,$event)"  data-url="/api/countries" :value-key="`name.${$lang.current}`"></select3>
                </form-input>

                <form-input :form="form" property="city_id">
                    <select3 :disabled="!o.country_id" :value="o.city" @input="changeOfficeCity(o, $event)" :data-url="`/api/countries/${o.country_id}/cities`" :value-key="`name.${$lang.current}`"></select3>
                </form-input>
                <form-input :form="form" property="area_id">
                    <select3 :disabled="!o.city_id" :value="o.area" @input="changeOfficeArea(o, $event)" :data-url="`/api/cities/${o.city_id}/areas`" :value-key="`name.${$lang.current}`"></select3>
                </form-input>

                <form-input :form="form" property="subarea_id">
                    <select3 :disabled="!o.area_id" :value="o.subarea" @input="o.subarea_id = $event.id; o.subarea = $event" :data-url="`/api/areas/${o.area_id}/subareas`" :value-key="`name.${$lang.current}`"></select3>
                </form-input>

                <form-input :form="form" property="street" label="Street">
                    <input v-model="o.street" type="text" class="form-control" placeholder="Street address">
                </form-input>

                <form-input :form="form" property="longitude" label="Type Street name and place Marker">
                    <location-finder disable-input :value="{longitude: parseFloat(o.longitude), latitude: parseFloat(o.latitude)}" @input="o.longitude = $event.longitude; o.latitude = $event.latitude"></location-finder>
                </form-input>

                <form-input :form="form" property="registration_number" label="Registration Number">
                    <input v-model="o.registration_number" type="text" class="form-control" placeholder="Registration Number">
                </form-input>

                <form-input :form="form" property="tax_number" label="Tax Number">
                    <input v-model="o.tax_number" type="text" class="form-control" placeholder="Tax Number">
                </form-input>

                <form-input :form="form" property="identification_number" label="Identification Number">
                    <input v-model="o.identification_number" type="text" class="form-control" placeholder="Identification Number">
                </form-input>

                <div class="text-right">
                    <confirm-popover @confirm="removeOffice(ind)">
                        <i class="fa fa-times"></i> Delete Office
                    </confirm-popover>
                </div>

                <div :class="{'has-error': form.errors.has('offices.'+ind+'.street')}">
                    <span class="help-block" v-show="form.errors.has('offices.'+ind+'.street')">
                        {{ form.errors.get('offices.'+ind+'.street') }}
                    </span>
                </div>

            </block>
        </div>


    </div>
</template>

<style>
.crm-offices {
    margin-bottom: 15px;
}

.m-form .team-offices .m-form__group {
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>

<script>
export default {
    props: ['form'],
    data() {
        return {
            showForm: false,
            office: {
                name : '',
                country_id: null,
                country: null,
                city_id: null,
                city: null,
                area_id: null,
                area: null,
                subarea_id: null,
                subarea: null,
                longitude: null,
                latitude: null,
                street: '',
                registration_number: '',
                tax_number: '',
                identification_number: '',
                emails: [],
                phones: [],
                websites: [],
            }
        };
    },
    methods: {
        addOffice() {
            if (!Array.isArray(this.form.offices)) {
                throw Error('Form must contain offices array');
            }

            if (this.office.country_id) {
                this.$emit('change');
                this.form.offices.push(this.office);
                this.office = {
                    name : '',
                    country_id: null,
                    country: null,
                    city_id: null,
                    city: null,
                    area_id: null,
                    area: null,
                    subarea_id: null,
                    subarea: null,
                    longitude: null,
                    latitude: null,
                    street: '',
                    registration_number: '',
                    tax_number: '',
                    identification_number: '',
                    emails: [],
                    phones: [],
                    websites: [],
                };
                this.showForm = false;
            }

        },

        removeOffice(index) {
            this.$emit('change');
            this.form.offices.splice(index, 1);
        },
        changeCountry(country) {
            this.office.country_id = country.id;
            this.office.country = country;
            this.office.city = null;
            this.office.city_id = null;
            this.office.area = null;
            this.office.area_id = null;
            this.office.subarea = null;
            this.office.subarea_id = null;
        },
        changeCity(city) {
            this.office.city = city;
            this.office.city_id = city.id;
            this.office.area = null;
            this.office.area_id = null;
            this.office.subarea = null;
            this.office.subarea_id = null;
        },
        changeArea(area) {
            this.office.area = area;
            this.office.area_id = area.id;
            this.office.subarea = null;
            this.office.subarea_id = null;
        },
        changeOfficeCountry(office,country){
            office.country_id = country.id;
            office.country = country;
            office.city = null;
            office.city_id = null;
            office.area = null;
            office.area_id = null;
            office.subarea = null;
            office.subarea_id = null;
        },
        changeOfficeCity(office,city) {
            office.city = city;
            office.city_id = city.id;
            office.area = null;
            office.area_id = null;
            office.subarea = null;
            office.subarea_id = null;
        },
        changeOfficeArea(office,area) {
            office.area = area;
            office.area_id = area.id;
            office.subarea = null;
            office.subarea_id = null;
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/TeamOffice.vue